import {
  SESSION_BROADCAST_CHANNEL,
  SESSION_BROADCAST_TYPE_FORCE_LOGOUT,
  SESSION_LOGOUT_REASON_ABSOLUTE,
  SESSION_LOGOUT_REASON_IDLE,
  SESSION_LOGOUT_REASON_REMOTE,
} from "./session.constants";
import {
  clearClientAuthStorage,
  setForceInteractiveLogin,
  setSessionEnded,
  suppressReturnUrlCapture,
} from "./sessionEnded";
import { clearReturnUrl } from "./sessionReturnUrl";

const INTERACTIVE_REAUTH_REASONS = new Set([
  SESSION_LOGOUT_REASON_IDLE,
  SESSION_LOGOUT_REASON_ABSOLUTE,
  SESSION_LOGOUT_REASON_REMOTE,
]);

const TAB_ID_KEY = "ctpo-tab-id";

export function getSessionTabId() {
  try {
    let id = sessionStorage.getItem(TAB_ID_KEY);
    if (!id) {
      id = `ctpo-tab-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
      sessionStorage.setItem(TAB_ID_KEY, id);
    }
    return id;
  } catch {
    return `ctpo-tab-fallback-${Math.random().toString(36).slice(2)}`;
  }
}

export function sessionLogout(
  instance,
  account,
  { reason = "manual", broadcast = false } = {},
) {
  suppressReturnUrlCapture();
  clearReturnUrl();
  setSessionEnded();
  if (INTERACTIVE_REAUTH_REASONS.has(reason)) {
    setForceInteractiveLogin();
  }

  if (broadcast && typeof BroadcastChannel !== "undefined") {
    try {
      const ch = new BroadcastChannel(SESSION_BROADCAST_CHANNEL);
      ch.postMessage({
        type: SESSION_BROADCAST_TYPE_FORCE_LOGOUT,
        reason,
        tabId: getSessionTabId(),
      });
      ch.close();
    } catch (e) {
      console.debug("sessionLogout broadcast failed", e);
    }
  }

  try {
    instance?.clearCache?.();
  } catch (e) {
    console.debug("sessionLogout clearCache failed", e);
  }

  clearClientAuthStorage();
  window.location.replace(`${window.location.origin}/goodbye`);
}
